import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { Steps } from '@/features/zones/Create/steps/Steps'

interface ZoneCreationSummary {
	zonePrice: number
	boxPrice: number
	soundreefPrice: number
	newTotalZones: number
	newTotalBoxes: number
	newTotalSoundreef: number
	newZones: number
	newBoxes: number
	newSoundreef: number
	total: number
}

interface ZonesState {
	lastDeletedZoneId: number | null
	deleteCounter: number
	createZone: {
		currentStep: Steps
		summary: ZoneCreationSummary
	}
}

const initialState: ZonesState = {
	lastDeletedZoneId: null,
	deleteCounter: 0,
	createZone: {
		currentStep: Steps.ZoneSettings,
		summary: {
			zonePrice: 0,
			boxPrice: 0,
			soundreefPrice: 0,
			newTotalZones: 0,
			newTotalBoxes: 0,
			newTotalSoundreef: 0,
			newZones: 0,
			newBoxes: 0,
			newSoundreef: 0,
			total: 0,
		},
	},
}

const zonesSlice = createSlice({
	name: 'zones',
	initialState,
	reducers: {
		zoneDeleted: (state, action: PayloadAction<number>) => {
			state.lastDeletedZoneId = action.payload
			state.deleteCounter += 1 // Increment counter to trigger refetches
		},
		resetZoneDeleted: (state) => {
			state.lastDeletedZoneId = null
		},
		// Zone creation actions
		setZoneCreationStep: (state, action: PayloadAction<Steps>) => {
			state.createZone.currentStep = action.payload
		},
		resetZoneCreation: (state) => {
			state.createZone.currentStep = Steps.ZoneSettings
		},
		setZoneCreationSummary: (
			state,
			action: PayloadAction<ZoneCreationSummary>
		) => {
			state.createZone.summary = action.payload
		},
	},
})

export const {
	zoneDeleted,
	resetZoneDeleted,
	setZoneCreationStep,
	resetZoneCreation,
	setZoneCreationSummary,
} = zonesSlice.actions
export const zonesReducer = zonesSlice.reducer
